module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-v2-custom",
    class: [_vm.themeClass(), {
      'table-v2-custom--responsive': _vm.responsive
    }]
  }, [_c('div', {
    staticClass: "table-v2-inner-spacing"
  }, [(_vm.$slots.tableHeader) ? _c('div', {
    staticClass: "table-header"
  }, [_vm._t("tableHeader")], 2) : _vm._e(), _vm._v(" "), _c('v-data-table', {
    ref: "table",
    class: _vm.tableClasses,
    attrs: {
      "headers": _vm.computedHeaders,
      "items": _vm.data || [],
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "loading": _vm.loading,
      "hide-default-footer": _vm.hideFooter,
      "items-per-page": _vm.itemsPerPage
    },
    on: {
      "update:sort-by": _vm.handleSortChange,
      "update:sort-desc": _vm.handleSortDescChange
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [_c('tr', {
          class: _vm.getRowClass(index)
        }, _vm._l((_vm.computedHeaders), function(header) {
          return _c('td', {
            key: header.value,
            class: _vm.getCellClass(header)
          }, [_vm._t(("item." + (header.value)), function() {
            return [_vm._v("\n              " + _vm._s(_vm.formatCellValue(item, header)) + "\n            ")]
          }, {
            "item": item,
            "value": item[header.value]
          })], 2)
        }), 0)]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._t("empty", function() {
          return [_c('div', {
            staticClass: "text-center pa-4"
          }, [_vm._v("\n            No data available\n          ")])]
        })]
      },
      proxy: true
    }, {
      key: "loading",
      fn: function() {
        return [_vm._t("loading", function() {
          return [_c('div', {
            staticClass: "text-center pa-4"
          }, [_vm._v("\n            Loading...\n          ")])]
        })]
      },
      proxy: true
    }], null, true)
  }), _vm._v(" "), _vm._t("bottom")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12286644"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/tables/components/StyledTable.vue
// module id = 1817
// module chunks = 0